import { render, staticRenderFns } from "./db-group-page.vue?vue&type=template&id=6b92eaac&"
import script from "./db-group-page.vue?vue&type=script&lang=js&"
export * from "./db-group-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports